// @ts-nocheck
/* eslint-disable */
export const bulkSearchIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="#172E63" d="M7.667 14a6.333 6.333 0 1 0 0-12.667 6.333 6.333 0 0 0 0 12.667" opacity=".4"/><path fill="#172E63" d="M14.2 14.667a.46.46 0 0 1-.327-.134l-1.24-1.24a.47.47 0 0 1 0-.66.47.47 0 0 1 .66 0l1.24 1.24a.47.47 0 0 1 0 .66.5.5 0 0 1-.333.134"/></svg>`,
    name: 'bulk-search' as const
};